import React from "react";
import "../Termcomp/Termhero.css";
import bar from "../../assets/images/herobar.svg";

function FrauddHero() {
  return (
    <div className="hero-content-term-container">
      <div className="term-header-sec">
      <h2>Fraud Alert</h2>
      </div>
    </div>
  );
}

export default FrauddHero;
